import { useParams, usePathname } from "next/navigation";

import { STRAIN_LIST_PAGE_CATEGORY_FILTERS } from "@/api/requests/getStrainLists";

const useIsStrainListPage = () => {
  const path = usePathname();
  const params = useParams();

  const isStrainListPage = path?.includes("/strains/lists");

  const strainListPageCategory = isStrainListPage && params?.slug?.[0];
  const strainListPageSlug =
    strainListPageCategory && strainListPageCategory !== "curated"
      ? params?.slug?.[1]
      : undefined;
  const strainListPageName = strainListPageSlug?.replaceAll("-", " ");

  const isStrainListPageNameEqualToFilterValue = (value?: string) =>
    !!(
      strainListPageName &&
      value &&
      strainListPageName.replaceAll("-", "_").toLowerCase() ===
        value.toLowerCase()
    );

  const strainListPageFilter =
    STRAIN_LIST_PAGE_CATEGORY_FILTERS[
      strainListPageCategory as keyof typeof STRAIN_LIST_PAGE_CATEGORY_FILTERS
    ];
  const isStrainListPageFilter = (name: string) =>
    strainListPageFilter === name;

  return {
    isStrainListPageFilter,
    isStrainListPageNameEqualToFilterValue,
    strainListPageName,
  };
};

export default useIsStrainListPage;
